import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import Emergent from './components/Emergent';
import Campaigns from './components/Campaigns';
import Recommendation from './components/Recommendation';
import WhatsNext from './components/WhatsNext';
import About from './components/About';
import Projects from './components/Projects';
import Experience from './components/Experience';
import XPosts from './components/XPosts';
import Contact from './components/Contact';
import Footer from './components/Footer';
import { Toaster } from './components/ui/toaster';
import './App.css';

const Portfolio = () => {
  return (
    <div className="min-h-screen bg-cream">
      <Header />
      <main>
        <Hero />
        <Emergent />
        <Campaigns />
        <Recommendation />
        <WhatsNext />
        <Experience />
        <Projects />
        <XPosts />
        <About />
        <Contact />
      </main>
      <Footer />
      <Toaster />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Portfolio />} />
        <Route path="*" element={<Portfolio />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
